<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3>AI-行业大模型</h3>
				</div>
				<div class="info-content" v-html="infoText"></div>
				
			</div>
		</div>
	</el-main>
</template>

<script>
export default {
	data() {
		return {
			infoText:`<h3><strong>面向特种设备专业场景的智能问答与知识检索引擎</strong></h3><p>“AI-行业大模型”是特规通企业版面向特种设备行业打造的专业智能问答与知识检索引擎，围绕“查得快、答得准、能核验、可追溯、可限定范围”的核心目标，帮助工程技术人员、质量管理人员、检验检测人员和企业管理人员在法规标准与企业资料中快速定位依据、理解条款要求、核验适用条件，并形成可复用、可引用、可追溯的专业结论。</p><p>与通用 AI 问答不同，特规通 AI-行业大模型建立在特种设备专业知识体系、正版法规标准资源和企业资料馆之上，面向设计、制造、安装、检验检测、使用管理、许可评审、质量体系建设、人员培训等真实业务场景进行优化。系统不仅能回答“是什么”，更强调“依据在哪里、适用条件是什么、能否回到原文核验”，让 AI 真正服务于专业工作和合规管理。</p><p>在交互方式上，系统默认采用自动模式：根据问题的复杂程度自动选择合适的回答深度，简单问题快速给出依据与结论，复杂问题转入多文件综合分析，用户无需在提问前判断该使用哪种模式。</p><p>在文字提问之外，系统同时支持图片上传与多模态分析。用户可以直接上传设备铭牌、设计图纸局部、检验报告页面、现场照片等图片，由 AI 先理解图片内容，再围绕图片开展法规标准查询、专业分析和连续对话，把“看图、查规范、问问题、找依据”并入同一个工作流程。</p><h3>1）专业知识底座：正版法规标准 + 结构化行业数据</h3><p>AI-行业大模型依托特规通法规标准库，覆盖法律、法规、规章、安全技术规范、TSG、行政文件、国家标准、行业标准、技术图书等特种设备行业常用资料，形成面向八大类特种设备及全生命周期业务场景的专业知识底座。</p><p>平台对法规标准文件进行结构化处理，将章节、条款、附录、术语、定义、表格、图片、公式等内容转化为可检索、可定位、可引用的知识单元，并建立文件编号、文件名称、发布机构、实施日期、效力状态、条款编号、图表公式编号等元数据体系。</p><p>这种高质量结构化数据，使 AI 不再只是“模糊理解文本”，而是能够在复杂规范体系中精准定位依据、识别条款边界、关联相关文件，并将回答落到具体法规标准、具体条款和具体内容上。</p><h3>2）行业模型适配：更懂特种设备专业语境</h3><p>特种设备行业具有明显的专业门槛，涉及设备类别、许可项目、设计制造环节、检验规则、质量保证体系、安全技术规范、材料与结构、试验与验收等大量专业概念。通用模型即使语言表达流畅，也容易出现概念混用、适用范围不清、依据不准或回答泛化的问题。</p><p>特规通 AI-行业大模型围绕特种设备法规标准体系和工程应用场景进行专业适配，重点提升以下能力：</p><ul><li>理解特种设备行业术语、设备分类、许可项目和业务环节；</li><li>区分法规、规章、安全技术规范、标准和技术图书的不同效力层级；</li><li>识别条款适用范围、前提条件、例外情形和边界要求；</li><li>将用户问题与相关法规标准、条款、表格、公式、图示进行匹配；</li><li>在回答中保留依据来源，支持用户回到原文核验；</li><li>面向许可评审、体系审核、设计校核、制造检验、人员培训等场景输出更贴近实际工作的回答。</li></ul><p>通过行业知识底座与专业模型能力结合，特规通 AI-行业大模型更加适合特种设备行业用户使用，能够在专业性、准确性、可核验性和业务适配性上形成明显优势。</p><h3>3）多模态能力：图片上传与图片分析，让业务材料直接进入专业对话</h3><p>在特种设备日常工作中，大量关键信息天然存在于图片之中：设备铭牌、设计图纸局部、检验报告页面、现场照片、表格和技术资料截图。以往的做法是先把图片内容手工转录为文字，再逐项查找法规标准、向 AI 补充背景，不仅费时，也容易遗漏图片中的关联信息。</p><p>AI-行业大模型在文字问答之外，支持图片上传与多模态分析。用户可直接上传图片，由系统先理解图片内容，再围绕图片开展法规标准查询、专业分析和连续对话，把“看图、查规范、问问题、找依据”连接到同一个工作流程中。</p><ul><li><strong>上传与解析能力</strong>：单次最多可上传 5 张图片，单张图片不超过 50 MB；支持围绕多张图片进行综合分析和连续追问。</li><li><strong>多图联合解析</strong>：用户可以同时提交同一设备的铭牌、图纸局部、报告页面或现场照片，系统在一轮对话中综合这些图片提供的信息，减少反复描述和多次上传。</li><li><strong>围绕图片查询法规标准</strong>：系统从图片中提取与任务相关的对象、术语、参数和线索，并结合特规通法规标准库检索相关要求。用户既可以询问“图片里是什么”，也可以进一步追问“这项内容涉及哪些法规标准”“需要重点核对哪些条款和适用条件”。</li><li><strong>基于同一图片连续追问</strong>：上传图片后，用户可在同一对话中补充条件、缩小范围、要求对比或解释。例如先提取铭牌参数，再询问设备分类和适用规范，随后要求列出仍需补充确认的信息，使复杂问题在多轮交互中逐步澄清。</li><li><strong>坚持依据导向</strong>：图片解析能力与法规标准检索、书单问答和证据链机制协同使用。对于专业问题，系统强调说明分析依据、适用边界和需要进一步确认的条件，帮助用户从图片线索快速转入法规标准核验。</li></ul><p>需要说明的是，图片分析用于辅助专业工作。涉及设备分类、合规判定、检验结论和安全处置等关键事项时，仍应结合完整资料、法规标准原文，并由专业人员复核后作出判断。</p><h3>4）四种问答模式：自动模式、快速回答、深入思考、书单问答</h3><p>企业版 AI-行业大模型在原有“快速回答”和“深入思考”的基础上，升级新增“自动模式”与“书单问答”，形成四种互补的专业问答方式，满足不同工作场景下的使用需求。其中自动模式为默认方式，用户不作选择时，系统会自动判断并给出恰当的回答。</p><ul><li><strong>自动模式：自动判断问题，无须手动选择（默认）</strong></li><p>自动模式是 AI-行业大模型的默认问答方式。用户提出问题时无需先判断问题类型，系统会先评估问题的复杂程度与信息需求，再自动融合“快速回答”与“深入思考”两种策略：问题指向明确、能够快速定位依据时，直接返回简明结论与对应条款；问题涉及多个文件、多个条件或需要跨文件核验时，自动转入更充分的语义分析与交叉检索，输出更完整、更结构化的回答。</p><p>这种“以问题定方式”的处理，使回答深度与问题难度相匹配：简单问题快速响应，减少等待和多余步骤；复杂问题深度推理，保留必要的依据、适用范围与逻辑关系。对于希望保持自然提问习惯、又要求回答质量稳定的用户，自动模式相当于“提问即可”的默认入口；确有需要时，用户仍可手动切换到快速回答、深入思考或书单问答，自行控制检索范围与回答深度。</p><li><strong>快速回答：快速定位依据，适合高频查询</strong></li><p>快速回答模式面向“我要尽快找到依据”的高频场景。用户提出问题后，系统会快速理解问题意图，在法规标准库中进行精准检索与定位，优先返回最相关、最可核验的条款依据和简明结论。</p><p>该模式适用于现场咨询、条款查询、设计校核、检验判定、标准适用性初步判断、术语定义查询等需要快速获得依据的场景，帮助用户减少翻标准、查目录、找关键词的时间。</p><li><strong>深入思考：多文件综合分析，适合复杂问题</strong></li><p>深入思考模式面向“问题复杂、涉及多个文件或多个条件”的专业场景。系统会对用户问题进行更充分的语义分析，结合设备类型、业务环节、适用范围、条款逻辑和相关文件进行综合检索与交叉核验，输出更完整、更结构化的回答。</p><p>该模式适用于方案论证、合规解释、跨文件协调、边界条件分析、许可评审准备、质量体系文件编写、培训学习等需要讲清楚背景、依据和逻辑关系的场景。</p><li><strong>书单问答：限定资料范围，回答更聚焦</strong></li><p>书单问答是特规通企业版升级后的重点能力。用户可在 AI 问答界面直接选择来自“企业资料馆”的书单，系统将在选定书单范围内进行检索、分析和回答。</p><p>书单可以来自企业已购电子标准、法规标准收藏书单、企业知识库或个人知识库。企业可围绕不同许可项目、设备类别、部门岗位、项目任务、质量体系、培训主题等建立专属书单，让 AI 只在当前任务相关的资料范围内回答问题。</p></ul><p>相比全库检索，书单问答能够有效减少无关资料干扰，使回答更加聚焦、准确和贴合企业实际业务场景。对于企业来说，这一能力意味着 AI 不仅能用平台法规标准回答问题，也能结合企业自己的内部资料、制度文件、项目文件、培训资料和技术文件开展专业问答。</p><h3>5）与企业资料馆全面打通：让企业资料真正进入 AI</h3><p>AI-行业大模型与“企业资料馆”全面打通，是特规通企业版的核心升级之一。企业资料馆中的四类资料均可通过书单接入 AI 使用：</p><ul><li><strong>企业已购电子标准</strong>：企业购买的正版电子法规标准，可在线查阅、下载，并可作为 AI 问答依据使用；</li><li><strong>法规标准收藏书单</strong>：企业根据自身业务范围创建或引用平台推荐书单，用于限定 AI 检索范围；</li><li><strong>企业知识库</strong>：企业主账号上传并管理的内部资料，可按书单分类，并授权子账号在 AI 中使用；</li><li><strong>个人知识库</strong>：子账号上传的个人专属资料，仅当前账号可见，可建立个人书单用于 AI 检索问答。</li></ul><p>通过这种打通机制，企业可以把“正版法规标准、企业内部资料、项目资料、制度文件、培训资料、个人工作文件”统一组织为可被 AI 使用的知识范围。AI 不再只是回答公共法规标准问题，而是可以进入企业真实资料体系，服务具体业务场景。</p><p>例如，企业可以建立“压力容器制造许可评审资料书单”“质量保证体系文件书单”“设计文件审查依据书单”“压力管道元件制造标准书单”“新员工培训资料书单”等，让 AI 在对应资料范围内进行问答、归纳、核对和解释。</p><h3>6）可信输出机制：不脱离依据，答案可核验</h3><p>特种设备行业属于强法规、强标准、强责任场景，AI 回答不能只追求流畅，更要强调依据、边界和可复核。AI-行业大模型在设计上坚持“有依据、有来源、可回查”的可信输出原则。</p><p>系统回答问题时，会优先基于法规标准原文和用户选定资料进行检索与归纳，尽量避免脱离依据的泛化回答。对于关键结论，系统会给出对应来源，支持用户回到原文件、原条款、原表格或原公式进行核验。</p><p>当问题缺少关键条件，或不同文件之间存在适用范围差异时，系统会提示需要补充的信息或说明适用边界，帮助用户避免将不适用的条款错误套用到具体业务场景中。</p><p>图片上传与多模态分析同样遵循这一原则：系统会说明从图片中提取到的信息、分析所依据的条款以及适用边界，对仍需人工确认的内容予以提示，使图片解析结果同样可以回到原文核验。</p><p>这种“回答 + 依据 + 原文回查”的机制，使 AI 输出可以服务于技术讨论、内部审核、许可评审准备、报告编写、制度起草和人员培训等需要留痕和复核的专业场景。</p><h3>7）面向企业合规与许可评审：让资料准备更高效</h3><p>对于特种设备生产、设计、制造、安装、检验检测和使用单位来说，法规标准清单是否完整、版本是否有效、资料来源是否正版、依据引用是否准确，是许可评审和合规管理中的重要问题。</p><p>AI-行业大模型与企业资料馆联动后，可以帮助企业围绕许可项目和业务范围建立法规标准书单、整理企业内部资料、核对条款依据、辅助编写制度文件、解释质量保证体系要求，并在评审准备过程中快速检索相关资料。</p><p>企业还可以通过法规标准收藏书单导出正版来源说明，用于许可评审、体系审核、监督检查和内部合规审查等场景。AI 则可以基于这些书单进行问答和资料核验，帮助企业提高准备效率，减少资料遗漏和依据不清的问题。</p><h3>8）面向培训学习：让专业知识更容易理解和沉淀</h3><p>特种设备法规标准体系庞大，很多条款理解需要结合设备类型、业务环节和工程背景。AI-行业大模型可以作为企业培训和个人学习的辅助工具，帮助新员工、工程技术人员和质量管理人员更快理解法规标准要求。</p><p>用户可以围绕某一类设备、某一个许可项目、某一套培训教材或某一批企业内部资料建立学习书单，并在 AI 中进行问答。系统可以帮助解释术语、梳理条款逻辑、归纳学习重点、对比不同文件要求，并引导用户回到原文进行核验。</p><p>通过“书单 + AI”的方式，企业可以把分散的法规标准、培训资料和内部经验沉淀为可持续使用的学习资源，让培训不再只依赖人工讲解和零散文件传递，而是形成更可复用、更可追溯的知识学习环境。</p><h3>9）典型应用场景</h3><p>AI-行业大模型可广泛应用于特种设备企业的日常工作和合规管理场景，包括：</p><ul><li>法规标准条款查询与原文核验；</li><li>设计、制造、安装、检验检测过程中的依据查找；</li><li>材料、部件、术语、公式、检验项目等内容检索；</li><li>设备铭牌与参数照片的识别、要素提取与适用法规标准查询；</li><li>设计图纸、技术条件截图的条款检索与复核要点梳理；</li><li>检验报告、质量证明和记录页面的字段识别与专业含义解释；</li><li>现场照片与问题线索的合规梳理与后续核查方向建议；</li><li>多张图片（铭牌、图纸、报告、记录）交叉核对与差异比对；</li><li>许可评审法规标准清单准备；</li><li>质量保证体系文件编写与核对；</li><li>企业内部制度、技术文件、项目资料问答；</li><li>新员工培训、考证学习和岗位能力提升；</li><li>专项项目资料归集与问答；</li><li>监督检查、内部审核和问题整改资料准备。</li></ul><p>通过这些场景，AI-行业大模型把“查资料、看规范、问问题、找依据、做引用”整合到同一个工作流程中，显著提升企业专业知识使用效率。</p><h3>10）核心价值：让 AI 真正服务特种设备专业工作</h3><p>特规通企业版 AI-行业大模型的核心价值，不是简单提供一个聊天入口，而是将正版法规标准库、结构化行业数据、企业资料馆、书单管理和专业 AI 问答能力连接起来，形成面向特种设备企业的知识应用引擎。</p><p>它帮助用户实现：</p><ul><li>在海量法规标准中快速找到依据；</li><li>在复杂条款体系中理解适用条件；</li><li>默认以自动模式匹配问题复杂度，简单问题快速响应、复杂问题深度推理，无须手动切换；</li><li>在企业资料范围内开展精准问答；</li><li>通过书单限定 AI 检索边界，减少无关干扰；</li><li>将企业内部资料接入 AI，形成可复用知识资产；</li><li>将回答结果回溯到原文依据，满足专业核验要求；</li><li>服务许可评审、合规审核、质量体系建设和人员培训。</li></ul><p>总体而言，AI-行业大模型是特规通企业版连接“正版法规标准、企业资料管理和专业 AI 应用”的核心能力。随着图片上传与多模态分析能力的加入，AI 的输入从文字进一步扩展到设备铭牌、设计图纸、检验报告和现场照片，让“从图片到依据”的距离进一步缩短。它让特种设备行业用户不仅能更快查到资料，更能更准确地理解资料、更规范地引用资料、更高效地使用企业知识，从而提升专业工作效率与合规管理水平。</p>`
		};
	}
};
</script>

<style lang="less" scoped>
.info-wrap {
	margin-left: 20px;
	padding: 20px 0 !important;
	font-size: 14px;
	color: #475569;
	line-height: 1.8;
	background-color: #fff;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
	border-radius: 12px;
	 min-height: calc(100vh - 120px);
	h3 {
		margin: 0 0 10px;
		font-weight: 600;
		font-size: 24px;
		color: #334155;
	}
}
.info-item {
	margin-bottom: 20px;
}
.info-head {
	margin-bottom: 25px;
	padding-bottom: 15px;
	border-bottom: 1px dashed #e2e8f0;
	.topbox {
		color: #94a3b8;
		dd {
			margin: 0 30px 0 0;
		}
	}
}
</style>

<style lang="less">
.info-content {
		padding: 0 30px;
		color: #0f172a;
	}

	.info-content h2 {
		margin: -4px 0 0 !important;
	}


	.info-content ul {
		li {
			line-height: 30px !important;
		}
	}

	.info-content p {
		margin-top: 6px !important;
		margin-bottom: 6px !important;
		line-height: 24px !important;
	}

	.info-content h3 {
		margin: 16px 0 6px !important;
	}

	.info-content h5 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		margin-top: 10px;
	}

	.info-content h6 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		position: relative;
	}

	.info-content h6:before {
		content: ' ';
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #155dfc;
		border-radius: 50%;
		margin-right: 10px;
		position: absolute;
		top: 16px;
		left: 18px;
	}

	.info-box {
		padding-bottom: 30px;
	}

	.info-content li::marker {
		color: #1456f0;
	}
</style>